import { Color } from "three";
import { VBase } from "./VBase";
import VUtil from "../VUtils";
import { VScrollViewHonrizontal } from "./_VScrollViewHorizontal";
import { VScrollViewVerticle } from "./_VScrollViewVerticle";
import { VHorizontalLayout, VVerticleLayout } from "../UILayout/VLayout";

const defaultOptions = {
  map: null,
  color: 0xffffff,
  opacity: 1.0,
  uiObjs: null,
  selectColor: 0xffffff,
  selectImage: null,
  width: 1,
  height: 0.2,
  gap: 0.02,
  axis: "horizongtal",
  radius: 0.02,
  defaultIndex: 0,
  responseForSelectd: false,
  elementStateChangeColor: null,
  elementStateChangeImage: null,

  disabledColor: 0xc8c8c8,
};

/* 
  使用案例

      const btn_hoverPath = "/assets/vrUI/Editpanel/btn_hover.png";
      const btn_selectPath = "/assets/vrUI/Editpanel/btn_select.png";
      const sceneIconPath = "/assets/vrUI/Editpanel/sceneIcon.png";
      const materialIconPath = "/assets/vrUI/Editpanel/materialIcon.png";
      const wayIconPath = "/assets/vrUI/Editpanel/wayIcon.png";
      const modelIconPath = "/assets/vrUI/Editpanel/modelIcon.png";
      const terrainIconPath = "/assets/vrUI/Editpanel/terrainIcon.png";
      const hoverBg = await this.manager.loadManager.loadTexture(btn_hoverPath);
      const selectBg = await this.manager.loadManager.loadTexture(
        btn_selectPath
      );

      const sceneIcon = await this.manager.loadManager.loadTexture(
        sceneIconPath
      );
      const materialIcon = await this.manager.loadManager.loadTexture(
        materialIconPath
      );
      const wayIcon = await this.manager.loadManager.loadTexture(wayIconPath);
      const modelIcon = await this.manager.loadManager.loadTexture(
        modelIconPath
      );
      const terrainIcon = await this.manager.loadManager.loadTexture(
        terrainIconPath
      );

      this.itemInfos = [
        {
          icon: sceneIcon,
          name: "场景模型",
        },
        {
          icon: terrainIcon,
          name: "地形",
        },
        {
          icon: materialIcon,
          name: "材质库",
        },

        {
          icon: modelIcon,
          name: "模型库",
        },
        {
          icon: wayIcon,
          name: "道路",
        },
      ];

      this.selectIndex = 0;

      this.uiObjs = [];
      for (var i = 0; i < this.itemInfos.length; i++) {
        const tempContainer = this.uiLib.createContainer({
          width: 0.35,
          height: 0.12,
          radius: 0.02,
          dragable: false,
          color: 0xffffff,
          map: hoverBg,
          opacity: 1, // i === this.selectIndex ? 1 : 0.0,
        });
        const icon = this.uiLib.createImage({
          map: this.itemInfos[i].icon,
          color: 0xafbbe3,
          width: 0.1,
          height: 0.1,
          radius: 0,
        });
        tempContainer.add(icon);
        icon.position.z = 0.001;
        icon.position.x = -0.095;
        const nameText = this.uiLib.createText({
          text: this.itemInfos[i].name,
          textColor: 0xafbbe3,
          textSize: 0.045,
          font: "bold",
          align: "left",
        });
        tempContainer.add(nameText);
        nameText.position.z = 0.001;
        nameText.position.x = -0.025;
        tempContainer.position.z = 0.001;
        tempContainer._editPanelIndex = i;
        tempContainer._icon = icon;
        tempContainer._nameText = nameText;
        this.uiObjs.push(tempContainer);
      }

      // tabcontrol
      this.tabControl = this.uiLib.createTabControl({
        selectImage: selectBg,
        width: 0.5,
        height: 0.8,
        radius: 0.0,
        axis: "verticle",
        gap: 0.01,
        opacity: 0.0,
        uiObjs: this.uiObjs,
        defaultIndex: this.selectIndex,
      });
      // 注册光标进入元素事件
      this.tabControl.addOnElementHoverEnterEvent((obj) => {
        obj._icon.material.color = new Color(0xffffff);
        if (obj._nameText.children.length > 0)
          VUtil.setTextColor(obj._nameText.children[0], 0xffffff);
      });
      // 注册光标离开元素事件
      this.tabControl.addOnElementHoverExitEvent((obj) => {
        obj._icon.material.color = new Color(0xafbbe3);
        if (obj._nameText.children.length > 0)
          VUtil.setTextColor(obj._nameText.children[0], 0xafbbe3);
      });
      // 注册点击元素事件
      this.tabControl.addOnElementClickEvent((obj, index) => {
        this.selectIndex = index;
        console.log("当前选择：", obj, index);
      });

      this.uiLib.addUIToScene(this.tabControl);

*/

export class VTabControl extends VBase {
  /**
   * 创建单选的按钮组，用于分页控制，如["背包","技能","属性"]等
   * options:
   * {
   *      priority: 优先级，默认为1，值越小越靠前
   *      renderOrder: 渲染顺序，默认为99999
   *      map: 背景贴图，不是贴图地址，默认为null
   *      color: 背景颜色。默认为 0xffffff
   *      opacity: 1,按钮背景透明度，默认为1，不透明
   *      uiObjs: 分页按钮内容，VContainer数组，其他元素需要用VContainer包裹,不要用VButton。默认为null
   *      selectColor: 当前选中的分页按钮颜色，默认为 0xffffff
   *      selectImage: 当前选中的分页按钮背景图片，不是图片地址，默认为null
   *      width: 按钮组宽度，默认为 1
   *      height: 按钮组高度，默认为 0.2
   *      gap: 按钮之间的间隙，默认为0.02
   *      radius: 圆角半径，设为0则是矩形，默认为0.01
   *      axis: 按钮组排列方式，"horizongtal"-水平排列  "verticle"-垂直排列，默认为"horizongtal"
   *      defaultIndex: 默认选中的分页按钮索引，默认为0
   *      responseForSelectd: 是否响应已选中的按钮，默认为false
   *      elementStateChangeColor: 按钮状态改变时的颜色对象，可以包含3个状态（"normal","hover","click"）也可以只设置其中某些状态,默认为null
   *      elementStateChangeImage: 按钮状态改变时的背景图片，可以包含3个状态（"normal","hover","click"）也可以只设置其中某些状态,默认为null
   *      elementStateChangeOpacity: 按钮状态改变时的透明度，可以包含3个状态（"normal","hover","click"）也可以只设置其中某些状态,默认为null
   *      disabledColor:  ui对象禁用颜色，默认为 0xC8C8C8
   * }
   * @param {*} options
   */
  constructor(options, vuiLib) {
    if (!options) options = {};

    const tempOptions = {
      priority: options.priority !== undefined ? options.priority : 1,
      renderOrder:
        options.renderOrder !== undefined ? options.renderOrder : 99999,
      map: options.map ? options.map : defaultOptions.map,
      color: options.color !== undefined ? options.color : defaultOptions.color,
      opacity:
        options.opacity !== undefined
          ? options.opacity
          : defaultOptions.opacity,
      uiObjs: options.uiObjs ? options.uiObjs : defaultOptions.uiObjs,
      selectColor:
        options.selectColor !== undefined
          ? options.selectColor
          : defaultOptions.selectColor,
      selectImage: options.selectImage
        ? options.selectImage
        : defaultOptions.selectImage,
      width: options.width !== undefined ? options.width : defaultOptions.width,
      height:
        options.height !== undefined ? options.height : defaultOptions.height,
      gap: options.gap !== undefined ? options.gap : defaultOptions.gap,
      radius:
        options.radius !== undefined ? options.radius : defaultOptions.radius,
      axis: options.axis ? options.axis : defaultOptions.axis,
      defaultIndex:
        options.defaultIndex !== undefined
          ? options.defaultIndex
          : defaultOptions.defaultIndex,
      responseForSelectd:
        options.responseForSelectd !== undefined
          ? options.responseForSelectd
          : defaultOptions.responseForSelectd,
      elementStateChangeColor: options.elementStateChangeColor
        ? options.elementStateChangeColor
        : null,
      elementStateChangeImage: options.elementStateChangeImage
        ? options.elementStateChangeImage
        : null,
      elementStateChangeOpacity: options.elementStateChangeOpacity
        ? options.elementStateChangeOpacity
        : null,
      disabledColor:
        options.disabledColor !== undefined
          ? options.disabledColor
          : defaultOptions.disabledColor,
    };
    if (tempOptions.opacity <= 0) tempOptions.opacity = 0.01;

    if (!tempOptions.uiObjs || tempOptions.uiObjs.length <= 0) {
      console.error("VTabControl error: 请输入正确的分页按钮");
      return;
    }

    super(tempOptions, vuiLib);
    this._vType = "VTabControl";

    this._otherProps = {
      uiObjs: tempOptions.uiObjs,
      selectColor: tempOptions.selectColor,
      selectImage: tempOptions.selectImage,
      gap: tempOptions.gap,
      axis: tempOptions.axis,
      defaultIndex: tempOptions.defaultIndex,
      elementStateChangeColor: tempOptions.elementStateChangeColor,
      elementStateChangeImage: tempOptions.elementStateChangeImage,
      elementStateChangeOpacity: tempOptions.elementStateChangeOpacity,
      responseForSelectd: tempOptions.responseForSelectd,
      onElementHoverEnter: [],
      onElementHoverExit: [],
      onElementClick: [],
    };

    this.selectColor = new Color(tempOptions.selectColor);
    //this.selectColor.convertSRGBToLinear();

    if (this._otherProps.defaultIndex < 0) this._otherProps.defaultIndex = 0;
    if (this._otherProps.defaultIndex >= this._otherProps.uiObjs.length)
      this._otherProps.defaultIndex = this._otherProps.uiObjs.length - 1;

    this.currentIndex = this._otherProps.defaultIndex;

    this.name = "VTabControl";

    if (this._otherProps.axis === "horizontal") {
      const layout = new VHorizontalLayout();
      layout.setSpacing(this._otherProps.gap);
      this.scrollview = new VScrollViewHonrizontal(
        {
          opacity: 0,
          width: this._baseProps.width,
          height: this._baseProps.height,
          radius: this._baseProps.radius,
          horizontalLayout: layout,
          showSlider: false,
        },
        this.vuilib
      );
    } else {
      const layout = new VVerticleLayout();
      layout.setSpacing(this._otherProps.gap);
      this.scrollview = new VScrollViewVerticle(
        {
          opacity: 0,
          width: this._baseProps.width,
          height: this._baseProps.height,
          radius: this._baseProps.radius,
          verticleLayout: layout,
          showSlider: false,
        },
        this.vuilib
      );
    }
    this.scrollview.addOnElementHoverEnterEvent((obj) => {
      this._onElementHoverEnter(obj);
    });
    this.scrollview.addOnElementHoverExitEvent((obj) => {
      this._onElementHoverExit(obj);
    });
    this.add(this.scrollview);

    for (var i = 0; i < this._otherProps.uiObjs.length; i++) {
      let ui = this._otherProps.uiObjs[i];

      if (ui._vType !== "VContainer") {
        console.error("VTabControl error: 分页按钮需要用VContainer包裹");
        continue;
      }

      ui._vTabIndex = i;
      ui._priority = this._priority - 1; // 将选项的优先级提高
      ui.onVRClick = (obj) => {
        this._onClickBtn(obj);
      };
      this.scrollview.addContent(ui);
    }

    const tempObj = this._otherProps.uiObjs[this._otherProps.defaultIndex];
    this.srcColor = tempObj.material.color.clone();
    this.srcMap = tempObj.material.map;
    tempObj.material.color = this.selectColor;
    if (this._otherProps.selectImage) {
      tempObj.material.map = this._otherProps.selectImage;
    }

    this.setSomethingForLater(this);
  }

  /**
   * 为添加到tabcontrol才后创建的ui子对象添加一些设置（主要针对文字）
   * @param {*} uiContent
   */
  setSomethingForLater(uiContent) {
    if (this.scrollview) this.scrollview.setSomethingForLater(uiContent);
  }

  _onElementHoverEnter(target) {
    if (!this._baseProps.enabled) return;

    for (var i = 0; i < this._otherProps.onElementHoverEnter.length; i++) {
      this._otherProps.onElementHoverEnter[i](target);
    }

    if (this._otherProps.elementStateChangeColor) {
      if (this._otherProps.elementStateChangeColor.hover !== undefined) {
        target.material.color = new Color(
          this._otherProps.elementStateChangeColor.hover
        );

        VUtil.convertSRGBToLinear(target.material);
      }
    }
    if (target._vTabIndex !== this.currentIndex) {
      if (this._otherProps.elementStateChangeImage) {
        if (this._otherProps.elementStateChangeImage.hover) {
          target.material.map = this._otherProps.elementStateChangeImage.hover;
          target.material.needsUpdate = true;
        }
      }

      if (this._otherProps.elementStateChangeOpacity) {
        if (this._otherProps.elementStateChangeOpacity.hover != undefined) {
          target.material.opacity =
            this._otherProps.elementStateChangeOpacity.hover;
        }
      }
    }
  }

  _onElementHoverExit(target) {
    if (!this._baseProps.enabled) return;

    for (var i = 0; i < this._otherProps.onElementHoverExit.length; i++) {
      this._otherProps.onElementHoverExit[i](target);
    }

    if (this._otherProps.elementStateChangeColor) {
      if (target._vTabIndex !== this.currentIndex) {
        if (this._otherProps.elementStateChangeColor.normal !== undefined) {
          target.material.color = new Color(
            this._otherProps.elementStateChangeColor.normal
          );

          VUtil.convertSRGBToLinear(target.material);
        } else target.material.color = this.srcColor;
      } else target.material.color = this.selectColor;
    }
    if (target._vTabIndex !== this.currentIndex) {
      if (this._otherProps.elementStateChangeImage) {
        if (this._otherProps.elementStateChangeImage.normal) {
          target.material.map = this._otherProps.elementStateChangeImage.normal;
        } else target.material.map = this.srcMap;
        target.material.needsUpdate = true;
      }
      if (this._otherProps.elementStateChangeOpacity) {
        if (this._otherProps.elementStateChangeOpacity.normal != undefined) {
          target.material.opacity =
            this._otherProps.elementStateChangeOpacity.normal;
        } else {
          target.material.opacity = this._baseProps.opacity;
        }
      }
    }
  }

  _onClickBtn(obj) {
    if (!this._baseProps.enabled) return;
    if (
      !this._otherProps.responseForSelectd &&
      this.currentIndex === obj._vTabIndex
    ) {
      return;
    }

    const srcColor = obj.material.color.clone();
    const srcMap = obj.material.map;

    if (
      this._otherProps.elementStateChangeColor &&
      this._otherProps.elementStateChangeColor.click !== undefined
    ) {
      obj.material.color = new Color(
        this._otherProps.elementStateChangeColor.click
      );

      VUtil.convertSRGBToLinear(obj.material);

      // 0.1s后恢复
      setTimeout(() => {
        obj.material.color = this.selectColor;
      }, 100);
    } else {
      obj.material.color = this.selectColor;
    }

    if (
      this._otherProps.elementStateChangeImage &&
      this._otherProps.elementStateChangeImage.click
    ) {
      obj.material.map = this._otherProps.elementStateChangeImage.click;
      obj.material.needsUpdate = true;

      // 0.1s后恢复
      setTimeout(() => {
        if (this._otherProps.selectImage) {
          obj.material.map = this._otherProps.selectImage;
          obj.material.needsUpdate = true;
        }
      }, 100);
    } else {
      if (this._otherProps.selectImage) {
        obj.material.map = this._otherProps.selectImage;
        obj.material.needsUpdate = true;
      }
    }

    if (this._otherProps.elementStateChangeOpacity) {
      if (this._otherProps.elementStateChangeOpacity.click != undefined) {
        obj.material.opacity = this._otherProps.elementStateChangeOpacity.click;
        // 0.1s后恢复
        setTimeout(() => {
          if (this._otherProps.elementStateChangeOpacity.normal != undefined) {
            obj.material.opacity =
              this._otherProps.elementStateChangeOpacity.normal;
          }
        }, 100);
      }
    }

    if (
      this._otherProps.elementStateChangeColor &&
      this._otherProps.elementStateChangeColor.normal !== undefined
    ) {
      this._otherProps.uiObjs[this.currentIndex].material.color = new Color(
        this._otherProps.elementStateChangeColor.normal
      );
      VUtil.convertSRGBToLinear(
        this._otherProps.uiObjs[this.currentIndex].material
      );
    } else
      this._otherProps.uiObjs[this.currentIndex].material.color = this.srcColor;

    if (this._otherProps.elementStateChangeOpacity) {
      if (this._otherProps.elementStateChangeOpacity.normal != undefined)
        this._otherProps.uiObjs[this.currentIndex].material.opacity =
          this._otherProps.elementStateChangeOpacity.normal;
      else {
        this._otherProps.uiObjs[this.currentIndex].material.opacity =
          this._baseProps.opacity;
      }
    }

    this._otherProps.uiObjs[this.currentIndex].material.map = this.srcMap;
    this._otherProps.uiObjs[this.currentIndex].material.needsUpdate = true;

    this.srcColor = srcColor;
    this.srcMap = srcMap;

    this.currentIndex = obj._vTabIndex;

    // 这个需要放在最后
    if (this._otherProps) {
      for (var i = 0; i < this._otherProps.onElementClick.length; i++) {
        this._otherProps.onElementClick[i](obj, this.currentIndex);
        if (!this._otherProps) break;
      }
    }
  }

  getClickable() {
    if (!this.visible || !this._baseProps.enabled) return [];
    const res = [];
    for (var i = 0; i < this._otherProps.uiObjs.length; i++) {
      res.push(this._otherProps.uiObjs[i]);
    }
    return res;
  }

  /**
   * 增加一个 光标进入元素事件回调，回调参数为当前进入的元素对象
   * @param {*} value
   */
  addOnElementHoverEnterEvent(fun) {
    if (!fun) return;
    this._otherProps.onElementHoverEnter.push(fun);
  }

  /**
   * 移除一个 光标进入元素事件回调
   * @param {*} fun
   */
  removeOnElementHoverEnterEvent(fun) {
    if (!fun) return;
    let index = this._otherProps.onElementHoverEnter.indexOf(fun);
    if (index >= 0) {
      this._otherProps.onElementHoverEnter.splice(index, 1);
    }
  }

  /**
   * 移除所有 光标进入元素事件回调
   */
  removeAllOnElementHoverEnterEvent() {
    this._otherProps.onElementHoverEnter = [];
  }

  /**
   * 增加一个 光标离开元素事件回调，回调参数为当前离开的元素对象
   * @param {*} fun
   */
  addOnElementHoverExitEvent(fun) {
    if (!fun) return;
    this._otherProps.onElementHoverExit.push(fun);
  }

  /**
   * 移除一个 光标离开元素事件回调
   * @param {*} fun
   */
  removeOnElementHoverExitEvent(fun) {
    if (!fun) return;
    let index = this._otherProps.onElementHoverExit.indexOf(fun);
    if (index >= 0) {
      this._otherProps.onElementHoverExit.splice(index, 1);
    }
  }

  /**
   * 移除所有 光标离开元素事件回调
   */
  removeAllOnElementHoverExitEvent() {
    this._otherProps.onElementHoverExit = [];
  }

  /**
   * 增加一个 元素点击事件回调，回调参数为当前点击的树节点数据
   * @param {*} fun
   * @returns
   */
  addOnElementClickEvent(fun) {
    if (!fun) return;
    this._otherProps.onElementClick.push(fun);
  }

  /**
   * 移除一个 元素点击事件回调
   * @param {*} fun
   */
  removeOnElementClickEvent(fun) {
    if (!fun) return;
    let index = this._otherProps.onElementClick.indexOf(fun);
    if (index >= 0) {
      this._otherProps.onElementClick.splice(index, 1);
    }
  }

  /**
   * 移除所有 元素点击事件回调
   */
  removeAllOnElementClickEvent() {
    this._otherProps.onElementClick = [];
  }

  /**
   * 在外面设置当前选中的分页，也会触发对应的事件
   * TODO 切换分页后选中按钮的背景图片无法更新，必须光标滑过后才会显示，待修改
   * @param {*} index
   * @returns
   */
  setDefaultIndex(index) {
    this._otherProps.defaultIndex = index;

    if (this.currentIndex === index) return;

    this._onClickBtn(this._otherProps.uiObjs[index]);
  }
}
